/** @jsxImportSource @emotion/react */
import React from 'react';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import Text from 'ud-ui/components/text';
import * as S from './styles';

interface IProps extends DivProps {
  avatars: string[];
  overflowIndicator?: number;
}

function AvatarGroup(props: IProps) {
  const { avatars, overflowIndicator, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      {avatars.map((avatar, i) => {
        return (
          <S.Avatar key={i}>
            <img src={avatar} alt="avatar" />
          </S.Avatar>
        );
      })}

      {overflowIndicator && (
        <S.Avatar className="yellow">
          <Text isNew type="subtitle-4" color={theme.colors.DarkYellow}>
            +{overflowIndicator}
          </Text>
        </S.Avatar>
      )}
    </S.MainBlock>
  );
}

export default AvatarGroup;
